/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { color as colorTokens } from '@metro-ui/tokens/js';
var applyModifier = function (c, modifier, step) {
    switch (modifier) {
        case 'shade':
            return c.shade[step];
        case 'tint':
        default:
            return c.tint[step];
    }
};
// TODO: Simplify after standardizing color tokens to reduce edge-cases
export var getColor = function (colorString) {
    return colorString.replace(/(brand-(primary|secondary)|\w+)(?:-(tint|shade)-([1-9]0|95))?/, function (_, color, colorInstance, modifier, step) {
        switch (color) {
            case 'black':
            case 'white':
                return colorTokens.contrast[color];
            case 'danger':
            case 'attention':
            case 'success':
            case 'interaction':
            case 'neutral':
            case 'muted':
            case 'disabled':
            case 'inverted':
                return colorTokens[color];
            case 'brand-primary':
            case 'brand-secondary':
                return modifier && step
                    ? applyModifier(colorTokens.brand[colorInstance], modifier, step)
                    : colorTokens.brand[colorInstance].default;
            default:
                return modifier && step
                    ? applyModifier(colorTokens.palette[color], modifier, step)
                    : colorTokens.palette[color].default;
        }
    });
};
//# sourceMappingURL=getColor.js.map